// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__IM_m7","toolTipText":"styles_toolTipText__Nt1Ux"};